import { wmsApi } from '../../../config/apiClient';
import { ACCOUNTING_API } from '../../../config/api';

export interface CreateCartDto {
  WarehouseId: string;
  CartCode: string;
  CartName: string;
  CartType?: string;
}

export interface UpdateCartDto {
  Id: string;
  CartCode: string;
  CartName: string;
  Status: string;
  IsActive: boolean;
  CartType?: string;
}

export interface CreateShelfDto {
  WarehouseId: string;
  ShelfCode: string;
  ShelfName: string;
  TotalSlots: number;
}

export interface UpdateShelfDto {
  Id: string;
  ShelfCode: string;
  ShelfName: string;
  IsActive: boolean;
}

export interface UpdateSlotDto {
  Id: string;
  SlotCode: string;
  IsActive: boolean;
}

export const equipmentService = {
  // Carts
  getCarts: (warehouseId: string) =>
    wmsApi.get(ACCOUNTING_API.WMS_CARTS(warehouseId)),

  getCartDetail: (id: string) =>
    wmsApi.get(ACCOUNTING_API.WMS_CART_DETAIL(id)),

  createCart: (data: CreateCartDto) =>
    wmsApi.post(ACCOUNTING_API.WMS_CART_CREATE, data),

  updateCart: (data: UpdateCartDto) =>
    wmsApi.post(ACCOUNTING_API.WMS_CART_UPDATE, data),

  deleteCart: (id: string) =>
    wmsApi.post(ACCOUNTING_API.WMS_CART_DELETE, { Id: id }),

  generateCartBarcode: (id: string) =>
    wmsApi.post(ACCOUNTING_API.WMS_CART_BARCODE(id)),

  // Shelves
  getShelves: (warehouseId: string) =>
    wmsApi.get(ACCOUNTING_API.WMS_SHELVES(warehouseId)),

  getShelfDetail: (id: string) =>
    wmsApi.get(ACCOUNTING_API.WMS_SHELF_DETAIL(id)),

  createShelf: (data: CreateShelfDto) =>
    wmsApi.post(ACCOUNTING_API.WMS_SHELF_CREATE, data),

  updateShelf: (data: UpdateShelfDto) =>
    wmsApi.post(ACCOUNTING_API.WMS_SHELF_UPDATE, data),

  deleteShelf: (id: string) =>
    wmsApi.post(ACCOUNTING_API.WMS_SHELF_DELETE, { Id: id }),

  // Slots
  updateSlot: (data: UpdateSlotDto) =>
    wmsApi.post(ACCOUNTING_API.WMS_SLOT_UPDATE, data),

  clearSlot: (id: string) =>
    wmsApi.post(ACCOUNTING_API.WMS_SLOT_CLEAR(id)),

  generateSlotBarcode: (id: string) =>
    wmsApi.post(ACCOUNTING_API.WMS_SLOT_BARCODE(id)),
};
